module.exports = __webpack_public_path__ + "img/g-store.4c61edad.png";